import { render, staticRenderFns } from "./DocumentListSkeleton.vue?vue&type=template&id=62fd2f6c&scoped=true&"
import script from "./DocumentListSkeleton.vue?vue&type=script&lang=js&"
export * from "./DocumentListSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./DocumentListSkeleton.vue?vue&type=style&index=0&id=62fd2f6c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fd2f6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62fd2f6c')) {
      api.createRecord('62fd2f6c', component.options)
    } else {
      api.reload('62fd2f6c', component.options)
    }
    module.hot.accept("./DocumentListSkeleton.vue?vue&type=template&id=62fd2f6c&scoped=true&", function () {
      api.rerender('62fd2f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InformationTab/DocumentListSkeleton.vue"
export default component.exports